import { combineReducers } from "redux";

import user from "./User";
import laundryBookings from "./LaundryBookings";
import config from "./Config";
import errorReport from "./ErrorReport";
import data from "./Data";
import feed from "./Feed";
import bookingSystemBookings from "./BookingSystemBookings";

export default combineReducers({
  user,
  laundryBookings,
  config,
  errorReport,
  data,
  feed,
  bookingSystemBookings
});



// WEBPACK FOOTER //
// ./src/reducers/index.js